module.exports = __webpack_public_path__ + "static/media/p3.fd036609.jpg";